var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSource10(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 2.667,
    fill: "#000",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 15.5,
    height: 15.5,
    rx: 2.417,
    stroke: "#000",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.768 5.224l-1.078.791V4.86l1.078-.786h1.088v7.593H4.768V5.224zm6.682 4.255V6.26c-.02-.76-.377-1.147-1.068-1.161-.694.014-1.048.4-1.062 1.161V9.48c.014.767.368 1.155 1.062 1.162.691-.008 1.047-.395 1.068-1.162zm-3.219.063v-3.35c.007-.7.231-1.24.672-1.62a2.126 2.126 0 011.48-.562c.59 0 1.091.188 1.505.563.42.378.637.918.65 1.62V9.54c-.013.698-.23 1.237-.65 1.615-.414.375-.915.566-1.506.573a2.167 2.167 0 01-1.479-.573c-.44-.378-.665-.917-.672-1.615z",
    fill: "#000",
    fillOpacity: 0.6
  })));
}
export default SvgSource10;